/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Width_HelpInputs */



/**
* | output |
* | --- |
* | "Number of characters across the screen (1-100)" |
*
* @param {Options_Display_Width_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_width_help = /** @type {((inputs?: Options_Display_Width_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Width_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre de caractères sur l'écran (1-100)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzahl der Zeichen auf dem Bildschirm (1-100)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di caratteri sullo schermo (1-100)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Количество символов на экране (от 1 до 100)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de caracteres en la pantalla (1-100)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("屏幕上显示的字符数（1-100）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画面に表示される文字数（1～100）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्क्रीन पर वर्णों की संख्या (1-100)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número de caracteres na tela (1-100)")
	return /** @type {LocalizedString} */ ("Number of characters across the screen (1-100)")
});